import { track } from '../../vendor/splitmetrics-track';



export const EVENT_NAME = 'video_open';


export default (props) => {
  track(EVENT_NAME, props, { force: true });
};



// WEBPACK FOOTER //
// ./src/lib/track-event/video-open.js